export default __webpack_public_path__ + "359f7316eacf797349ea4248e5ccce67.svg";